/**
 * Myグループカテゴリー
 */
export const Category = {
  // プライベート
  プライベート: 1,
  // 共有
  共有: 2,
  // パブリック
  パブリック: 3,
} as const;

export type CategoryType = typeof Category[keyof typeof Category];
